/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { useLocalStorage as R, usePreferredLanguages as O } from "@vueuse/core";
import { ref as E, computed as M } from "vue";
import { createI18n as x, useI18n as z } from "vue-i18n";
let w;
try {
  w = R("preferred-language", null);
} catch {
  w = E(null);
}
let d, P = "en", $ = !1, t;
const C = () => {
  let e;
  return w.value ? e = [w.value] : e = [...O().value], e.find((s) => Object.keys(d).indexOf(s) !== -1) || P;
}, S = (e) => P = e, H = (e) => d = e, q = () => d, T = async (e) => {
  await k(e), t.global.locale.value = e, w.value = e;
}, K = (e) => {
  var g, y, h;
  const r = e in d, [s, a] = e.split("-");
  if (r && (!$ || a))
    return e;
  const o = s in d ? s : C(), c = d[o];
  let n;
  if ($)
    if (a && ((g = c.countries) != null && g.includes(a)))
      n = a;
    else {
      const l = t.global.country.value;
      l && ((y = c.countries) != null && y.includes(l)) ? n = l : n = c.defaultCountry || ((h = c.countries) == null ? void 0 : h[0]);
    }
  return n ? `${o}-${n}` : o;
}, B = async (e) => {
  e != null && e.defaultLocale && S(e.defaultLocale);
  const r = C();
  t = x({
    legacy: !1,
    globalInjection: !0,
    locale: r,
    fallbackLocale: P
  });
  const s = M(() => {
    var c;
    const [a, o] = (c = t.global.locale.value) == null ? void 0 : c.split("-");
    return { lang: a, country: o };
  });
  return t.global.country = M(() => {
    var a;
    return (a = s.value.country) == null ? void 0 : a.toLowerCase();
  }), t.global.dir = E("ltr"), t.global.isRtl = M(() => t.global.dir.value === "rtl"), t.global.lang = M(() => {
    var a;
    return (a = s.value.lang) == null ? void 0 : a.toLowerCase();
  }), e != null && e.autoLoadMessages && await k(r), {
    ...t,
    install: async (a, ...o) => {
      await t.install(a, ...o), ["country", "isRtl", "lang"].forEach((n) => {
        Object.defineProperty(a.config.globalProperties.$i18n, n, {
          get() {
            return t.global[n].value;
          }
        });
      });
    }
  };
}, k = async (e) => {
  if (!t)
    throw new Error("i18n not inizialized yet. Call setupI18n first.");
  const [r] = e.split("-"), s = e in d ? e : r, a = d[s];
  if (!a)
    throw new Error("Locale not found");
  if (
    // key not present
    !t.global.messages.value[s] || // key present but no messages inside (created by default by vue-i18n)
    t.global.messages.value[s] && Object.keys(t.global.messages.value[s]).length === 0
  ) {
    const { default: c } = await a.load();
    t.global.setLocaleMessage(s, c);
  }
  t.global.dir && (t.global.dir.value = a.rtl ? "rtl" : "ltr");
}, G = (e, r) => {
  const s = Object.keys(d), o = Object.entries(d).map(([l, i]) => i.countries ? ($ = !0, i.countries.map((f) => `${l}-${f}`).join("|")) : l).join("|"), c = C();
  let n = [], g, y, h;
  return n = e.map(({ locales: l = s, ...i }) => {
    var v;
    if ((v = i.meta) != null && v.is404)
      return g = i, { name: "oldcatchall", path: "oldcatchall", redirect: { path: "oldcatchall" } };
    const f = l.filter((u) => s.includes(u)), L = f.length ? s.filter((u) => !f.includes(u)) : [];
    return {
      ...i,
      path: `/:locale(${o})${i.path}`,
      beforeEnter: (u, j, b) => {
        const m = u.params.locale;
        if (L.includes(m)) {
          h = m, y = f.includes(m) ? m : f[0];
          const p = { ...u, params: { ...u.params, locale: y } };
          b(p);
        } else if (h && m === y && f.includes(h)) {
          const p = { ...u, params: { ...u.params, locale: h } };
          y = void 0, h = void 0, b(p);
        } else
          typeof i.beforeEnter == "function" ? i.beforeEnter.call(void 0, u, j, b) : b();
      }
    };
  }).filter((l) => l.name !== "oldcatchall"), n = n.concat([
    {
      // matches /validlanguage/invalidroute and redirects it to /validlanguage
      path: `/:locale(${o})/:pathMatch(.*)*`,
      redirect: (l) => ({ path: `/${c}` })
    },
    {
      // matches /invalidlanguage/anyroute and redirects it to /validlanguage/anyroute
      path: `/:locale(${$ ? "\\w{2,3}|\\w{2,3}-\\w{2,3}" : "\\w{2,3}"}\\b)/:pathMatch(.*)*`,
      redirect: (l) => {
        var v, u, j, b, m;
        const { locale: i, pathMatch: f } = l.params;
        let L = Array.isArray(f) ? f.join("/") : f;
        if (r != null && r.ambiguousLocaleParams && (Array.isArray(r.ambiguousLocaleParams) && r.ambiguousLocaleParams.includes(i) || r.ambiguousLocaleParams instanceof RegExp && r.ambiguousLocaleParams.test(i)) && (L = `${i}/${L}`), $) {
          const [p] = i.split("-"), I = (v = d[p]) == null ? void 0 : v.defaultCountry, A = I && ((j = (u = d[p]) == null ? void 0 : u.countries) != null && j.includes(I)) ? I : (m = (b = d[p]) == null ? void 0 : b.countries) == null ? void 0 : m[0];
          if (A)
            return { path: `/${p}-${A}/${L}` };
        }
        return { path: `/${c}/${L}` };
      }
    }
  ]), g ? (g.redirect = (l) => ({ path: `/${c}/${Array.isArray(l.params.pathMatch) ? l.params.pathMatch.join("/") : l.params.pathMatch}` }), n.push(g)) : n.push({
    // matches /anyroute (if not found) and redirects it to /validlanguage/anyroute
    // https://next.router.vuejs.org/guide/migration/#removed-star-or-catch-all-routes
    path: "/:pathMatch(.*)*",
    redirect: (l) => ({ path: `/${c}/${Array.isArray(l.params.pathMatch) ? l.params.pathMatch.join("/") : l.params.pathMatch}` })
  }), n;
}, J = (e) => {
  e.beforeEach(async (r, s, a) => {
    var n;
    const o = (n = r.params) == null ? void 0 : n.locale;
    let c;
    if (typeof o == "string") {
      const g = K(o);
      g === o ? await T(o) : c = { ...r, params: { ...r.params, locale: g } };
    }
    a(c);
  });
}, Q = () => z(), U = () => t, V = Symbol("useI18n"), W = Symbol("getTranslations");
export {
  J as addRouterHooks,
  T as changeLocale,
  U as getI18n,
  C as getPreferredLanguage,
  q as getTranslations,
  W as getTranslationsInjectionKey,
  Q as i18n,
  V as i18nInjectionKey,
  k as loadLocaleMessages,
  K as resolveLocale,
  S as setDefaultLocale,
  H as setTranslations,
  B as setupI18n,
  G as useLocalizedRoutes
};
